import { Component, Watch, Emit, Prop, Vue } from 'vue-property-decorator';
import ButtonFavoriteHeart from '@/components/button/ButtonFavoriteHeart.vue';
import ButtonMovie from '@/components/button/ButtonMovie.vue';
import store from '@/store';
import HistoryDirective from '@/directives/history';
import GaSendSite from '@/directives/GaSendSite';
import UtilMixin from '@/mixins/util';
import { isOptimaHotelUrl, hotelReserveLinkUrl } from '@/lib/functions';
import $ from 'jquery';
// @ is an alias to /src

@Component({
  components: {
    ButtonFavoriteHeart,
    ButtonMovie,
  },
  directives: {
    history: HistoryDirective,
    gasendsite: GaSendSite,
  },
})
export default class BoxHotel extends Vue.extend(UtilMixin) {
  // Provided by components that use this mixin (e.g. BoxArchivesHotel)
  protected words!: Dictionary;
  private isOpenAccess = false;
  get lang(): string {
    return this.$store.getters["auth/lang"];
  }
  @Prop()
  protected datas!: HotelDetail;

  get mapLink(): string {
    let result!: string;
    if (this.datas) {
      if (this.testMapLink(this.datas.map)) {
        let path = "/" + this.lang;
        if (this.lang === "ja") {
          path = "";
        }
        result = `${path}/hotel/name/${this.datas.slug}/map`;
      } else {
        result = this.datas.map;
      }
    }
    return result;
  }
  // @Emit()
  // private testMapLink(url: string): boolean {
  //   const regex = /^https:\/\/www\.google\.com\/maps\/embed/;
  //   return regex.test(url);
  // }
  get price(): string | undefined {
    return this.datas.price;
  }

  @Watch("isOpenAccess")
  private onChangeOpenAccess(newFlg: boolean, oldFlg: boolean) {
    const refs: any = this.$refs;
    if (newFlg) {
      $(refs.detail).stop().slideDown();
    } else {
      $(refs.detail).stop().slideUp();
    }
  }
  @Emit()
  private toggleDetail(): void {
    if (this.isOpenAccess) {
      this.isOpenAccess = false;
    } else {
      this.isOpenAccess = true;
    }
  }
  private isOptimaHotelUrlWithMghrwc(url: string): boolean {
    return isOptimaHotelUrl(url) && !!store.getters['auth/mghrwc'];
  }

  private hotelReserveLinkUrl(datas: HotelDetail, index: number): string {
    return hotelReserveLinkUrl(
      datas,
      index,
      this.lang,
      store.getters["auth/group"],
      !!store.getters['auth/mghrwc']
    );
  }
}
